import React from 'react';
import { BackArrowButton } from '@ui';
import { Routes, useNavigate } from 'react-router';

export const GoBackButton = () => {
  const navigate = useNavigate();

  return <BackArrowButton onClick={() => navigate(Routes.home)} />;
};
